
        window.pug_templates['multipar_premium'] = window.pug_mixins['multipar_premium'] = function(auction) {
          var pug_interp, attributes = this.attributes || {}, block = this.block || false;
          window.pug_mixin_level++;
      const { premium } = auction;
if (premium) {
if (premium.type === 'fixed') {
pug_html = pug_html + "\u003Cdiv class=\"mt-2 text-italic\"\u003E" + (pug.escape(null == (pug_interp = `A ${premium.amount}% buyer's premium will be added to the final sales price.`) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"mt-2 text-italic\"\u003E" + (pug.escape(null == (pug_interp = `A buyer's premium will be added to the final sales price depending on the amount of the final sales price.`) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}

          window.pug_mixin_level--;
          if (window.pug_mixin_level < 1) { var result = pug_html; pug_html=""; return result; }
        };
      